module.exports = __webpack_public_path__ + "img/image37.0ef93de8.png";